import React, { useContext, useEffect, useState } from 'react'
import styles from './LbAnalyticsPanel.module.css'
import { motion } from 'framer-motion'
import { FaUserCheck, FaCalendarAlt, FaChartLine, FaBolt } from 'react-icons/fa'
import { BASE_URL_API } from '../../../References/URLs'
import AuthContext from '../../../store/auth-context'
import ActiveStoreContext from '../../../store/ActiveStoreContext'
import { humanReadableTimePassed } from '../../../Helper/calculations'

const LbAnalyticsPanel = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();


    const metrics = [
        { label: 'Total Leads', value: 1287, icon: <FaUserCheck />, color: '#3f5efb' },
        { label: 'Leads Today', value: 34, icon: <FaBolt />, color: '#fc466b' },
        { label: 'Appointments', value: 172, icon: <FaCalendarAlt />, color: '#28a745' },
        { label: 'Conversion Rate', value: '12.7%', icon: <FaChartLine />, color: '#ff9900' }
    ]

    const [activities, setActivities] = useState([])

    const getRecentActivities = async () => {
        const response = await fetch(BASE_URL_API + "lb_getRecentActivities",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier: activeStore.storeIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setActivities(respo?.response)
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }

            console.log(respo)
        }
    }


    useEffect(() => {
        getRecentActivities()
    }, [])

    // setInterval(() => {
    //     getRecentActivities()
    // }, 20000);


    return (
        <div className={styles.analyticsWrapper}>
            <div className={styles.activityLog}>
                <h3>Recent Activity</h3>
                <div className={styles.activityLogList}>
                    {activities.map((act, idx) => (
                        <div key={idx} className={styles.eachActivity} >
                            <div className={styles.time}>{humanReadableTimePassed(act?.timestamp)}</div>
                            <div className={styles.text}>
                                <div className={styles.title} >{act?.title}</div>
                                <div className={styles.subTitle} >({act?.subTitle})</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* <h3>Analytics Overview</h3> */}

            {/* <div className={styles.metricsGrid}>
                {metrics.map((metric, idx) => (
                    <motion.div
                        key={idx}
                        className={styles.metricCard}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.1 }}
                    >
                        <div className={styles.icon} style={{ backgroundColor: metric.color }}>
                            {metric.icon}
                        </div>
                        <div className={styles.metricInfo}>
                            <h3>{metric.value}</h3>
                            <p>{metric.label}</p>
                        </div>
                    </motion.div>
                ))}
            </div> */}


        </div>
    )
}

export default LbAnalyticsPanel
